import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "poll-card__header poll-card__header--draft" }
const _hoisted_2 = { class: "poll-card__header-name" }
const _hoisted_3 = { class: "poll-card__footer" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "poll-card__header" }
const _hoisted_6 = { class: "poll-card__header-name" }
const _hoisted_7 = { class: "poll-card__footer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconPoll = _resolveComponent("IconPoll")
  const _component_IconPencilOutline = _resolveComponent("IconPencilOutline")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_IconTrashCanOutline = _resolveComponent("IconTrashCanOutline")
  const _directive_intersection_observer = _resolveDirective("intersection-observer")

  return ($props.draft)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "poll-card",
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.openDraft && $options.openDraft(...args)))
      }, [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_IconPoll, {
            class: "poll-card__header-icon",
            size: 20
          }),
          _createElementVNode("span", _hoisted_2, _toDisplayString($props.name), 1),
          ($options.canEditPollDraft)
            ? (_openBlock(), _createBlock(_component_NcButton, {
                key: 0,
                variant: "tertiary",
                title: $options.t('spreed', 'Edit poll draft'),
                "aria-label": $options.t('spreed', 'Edit poll draft'),
                onClick: _withModifiers($options.editDraft, ["stop"])
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconPencilOutline, { size: 20 })
                ]),
                _: 1
              }, 8, ["title", "aria-label", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_NcButton, {
            variant: "tertiary",
            title: $options.t('spreed', 'Delete poll draft'),
            "aria-label": $options.t('spreed', 'Delete poll draft'),
            onClick: _withModifiers($options.deleteDraft, ["stop"])
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconTrashCanOutline, { size: 20 })
            ]),
            _: 1
          }, 8, ["title", "aria-label", "onClick"])
        ]),
        _createElementVNode("span", _hoisted_3, _toDisplayString($options.pollFooterText), 1)
      ]))
    : (!$props.showAsButton)
      ? _withDirectives((_openBlock(), _createElementBlock("a", {
          key: 1,
          "aria-label": $options.t('spreed', 'Poll'),
          class: "poll-card",
          role: "button",
          onClick: _cache[1] || (_cache[1] = (...args) => ($options.openPoll && $options.openPoll(...args)))
        }, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_IconPoll, {
              class: "poll-card__header-icon",
              size: 20
            }),
            _createElementVNode("span", _hoisted_6, _toDisplayString($props.name), 1)
          ]),
          _createElementVNode("span", _hoisted_7, _toDisplayString($options.pollFooterText), 1)
        ], 8, _hoisted_4)), [
          [_directive_intersection_observer, $options.getPollData]
        ])
      : (_openBlock(), _createBlock(_component_NcButton, {
          key: 2,
          class: "poll-closed",
          variant: "secondary",
          onClick: $options.openPoll
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.t('spreed', 'See results')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
}